import type { TranslationKey } from "./en";

const zh: Partial<Record<TranslationKey, string>> = {
  "lang.label": "语言",
  "lang.select": "选择语言",
  "theme.toggle": "切换主题",
  "theme.light": "浅色模式",
  "theme.dark": "深色模式",
  "brand.name": "GuardAI（由 G-Data Labs 提供）",
  "brand.short": "GuardAI",
  "brand.subtitle": "安全巡逻",
  "brand.guardSystem": "警卫系统",
  "console.director": "总监控制台",
  "console.admin": "管理员控制台",
  "console.supervisor": "主管控制台",
  "role.administrator": "管理员",
  "role.director": "总监",
  "role.supervisor": "主管",
  "role.guard": "保安员",
  "nav.dashboard": "仪表板",
  "nav.liveActivity": "实时动态",
  "nav.devices": "设备",
  "nav.schedules": "排班",
  "nav.calendar": "日历",
  "nav.alerts": "警报",
  "nav.checkpoints": "检查点",
  "nav.reports": "报告",
  "nav.reportBuilder": "报告生成器",
  "nav.askAi": "询问 AI",
  "nav.admin": "管理",
  "nav.settings": "设置",
  "nav.deploy": "部署",
  "nav.scanMap": "扫描地图",
  "nav.users": "用户管理",
  "common.save": "保存",
  "common.cancel": "取消",
  "common.submit": "提交",
  "common.delete": "删除",
  "common.edit": "编辑",
  "common.search": "搜索",
  "common.filter": "筛选",
  "common.export": "导出",
  "common.clear": "清除",
  "common.viewAll": "查看全部",
  "common.back": "返回",
  "common.close": "关闭",
  "common.confirm": "确认",
  "common.add": "添加",
  "common.refresh": "刷新",
  "common.loading": "加载中…",
  "common.saving": "保存中…",
  "common.saved": "已保存",
  "common.error": "错误",
  "common.noData": "暂无数据",
  "common.required": "必填",
  "common.optional": "可选",
  "common.yes": "是",
  "common.no": "否",
  "common.all": "全部",
  "common.none": "无",
  "common.name": "名称",
  "common.status": "状态",
  "common.location": "位置",
  "common.time": "时间",
  "common.date": "日期",
  "common.actions": "操作",
  "common.today": "今天",
  "domain.scanEvent": "扫描事件",
  "domain.scanEvents": "扫描事件",
  "domain.checkpoint": "巡检点",
  "domain.checkpoints": "巡检点",
  "domain.hospital": "医院",
  "domain.hospitals": "医院",
  "domain.guard": "保安员",
  "domain.guards": "保安员",
  "domain.device": "设备",
  "domain.devices": "设备",
  "domain.patrol": "巡逻",
  "domain.security": "安保",
  "domain.shift": "班次",
  "domain.station": "站点",
  "search.placeholder": "搜索保安员、位置或扫描记录…",
  "notif.title": "通知",
  "notif.empty": "暂无新通知",
  "notif.viewAll": "查看所有通知",
  "notif.missedCheckpoint": "漏检巡检点警报",
  "status.active": "活跃",
  "status.inactive": "未活跃",
  "status.online": "在线",
  "status.offline": "离线",
  "status.pending": "待处理",
  "status.approved": "已批准",
  "status.denied": "已拒绝",
  "status.flagged": "已标记",
  "status.completed": "已完成",
  "status.missed": "已漏检",
  "status.onDuty": "在岗",
  "status.offDuty": "离岗",
  "auth.signIn": "登录",
  "auth.signingIn": "登录中…",
  "auth.signOut": "退出登录",
  "auth.username": "用户名",
  "auth.password": "密码",
  "auth.loginFailed": "登录失败",
  "auth.tagline": "保安员在任意站点扫描胸牌，主管即可在安全的仪表板上即时查看更新。",
  "dashboard.title": "安全巡逻中心",
  "dashboard.subtitle": "对每个巡检点进行实时监控",
  "dashboard.totalScans": "扫描总数",
  "dashboard.activeGuards": "在岗保安员",
  "dashboard.checkpoints": "巡检点",
  "dashboard.openAlerts": "未处理警报",
  "dashboard.recentActivity": "最近动态",
  "dashboard.noActivity": "暂无最近动态",
  "live.title": "实时巡逻动态",
  "live.subtitle": "实时呈现每一次胸牌扫描",
  "live.empty": "暂无动态",
  "live.waiting": "正在等待下一次扫描…",
  "devices.title": "已连接的巡逻设备",
  "devices.subtitle": "现场每台扫描设备的状态",
  "devices.lastSeen": "最后在线",
  "devices.battery": "电量",
  "devices.none": "暂无已连接设备",
  "schedules.title": "巡逻排班",
  "schedules.subtitle": "为保安员分配班次和巡检点",
  "schedules.addShift": "添加班次",
  "schedules.none": "暂无排班",
  "alerts.title": "安全警报",
  "alerts.subtitle": "需要关注的漏检巡检点和已标记事件",
  "alerts.none": "暂无活跃警报",
  "alerts.allClear": "一切正常——无需处理。",
  "alerts.acknowledge": "确认",
  "alerts.resolve": "解决",
  "reports.title": "安全报告",
  "reports.subtitle": "巡逻覆盖率、扫描量及完整性分析",
  "reports.builderTitle": "报告生成器",
  "reports.builderSubtitle": "设计专业报告——无需编写代码。",
  "reports.generate": "生成报告",
  "reports.noData": "此报告暂无数据",
  "ask.title": "询问 AI",
  "ask.greeting": "今天有什么可以帮您的？",
  "ask.placeholder": "询问任何关于巡逻、保安员或扫描的问题…",
  "ask.send": "发送",
  "ask.thinking": "思考中…",
  "admin.title": "系统管理",
  "admin.subtitle": "管理访问权限、审批和系统运行状况",
  "admin.pendingApplications": "待处理申请",
  "admin.systemHealth": "系统运行状况",
  "admin.uptime": "运行时间",
  "admin.storage": "存储",
  "admin.users": "用户",
  "admin.latency": "延迟",
  "users.title": "用户管理",
  "users.subtitle": "添加、编辑和停用平台账户",
  "users.addUser": "添加用户",
  "users.none": "未找到用户",
  "settings.title": "设置",
  "settings.subtitle": "管理您的账户和偏好设置",
  "settings.account": "账户",
  "settings.appearance": "外观",
  "settings.notifications": "通知",
  "settings.language": "语言",
  "deploy.title": "部署规划器",
  "deploy.subtitle": "规划、采集并验证巡检点布置",
  "deploy.plan": "规划",
  "deploy.capture": "采集",
  "deploy.verify": "验证",
  "map.title": "扫描地图",
  "map.subtitle": "查看整个场所内胸牌扫描发生的位置",
  "map.noScans": "暂无可显示的扫描记录",
  "profile.account": "账户",
  "profile.settings": "设置",
  "profile.help": "帮助与支持",
  "profile.darkMode": "深色模式",
  "profile.viewProfile": "查看个人资料",
  "footer.copyright": "© 2026 G-Data Labs. 保留所有权利。",
  "footer.terms": "使用条款",
  "footer.privacy": "隐私政策",
  // ── Auto-added: full dashboard content translations ──
  "admin.addGuard": "添加警卫",
  "admin.addNewGuard": "添加新警卫",
  "admin.addRoute": "添加路线",
  "admin.alertEmail": "警报通知邮箱",
  "admin.avgResponse": "平均响应",
  "admin.checkpointTimeout": "检查点超时（分钟）",
  "admin.checkpointsCount": "检查点（{n}）",
  "admin.colBadge": "工牌",
  "admin.colContact": "联系方式",
  "admin.colGuard": "警卫",
  "admin.colLastActive": "最近活跃",
  "admin.colRole": "角色",
  "admin.colRoutes": "巡逻路线",
  "admin.deactivatedPreviewDesc": "这是已停用账户在管理员视图中的显示方式。",
  "admin.deactivatedPreviewTitle": "已停用警卫预览",
  "admin.difficultyEasy": "简单",
  "admin.difficultyHard": "困难",
  "admin.difficultyMedium": "中等",
  "admin.employeeId": "员工编号：",
  "admin.errorAddGuard": "无法添加警卫。请重试。",
  "admin.errorAllFields": "所有字段均为必填项。",
  "admin.errorLoadDirectory": "目前无法加载警卫名录。",
  "admin.fieldEmail": "电子邮箱",
  "admin.fieldEmergencyContact": "紧急联系人",
  "admin.fieldEmployeeId": "Emory 员工编号",
  "admin.fieldFullName": "全名",
  "admin.fieldPhone": "电话",
  "admin.fieldRole": "角色",
  "admin.fieldTempPassword": "临时密码",
  "admin.gpsThreshold": "GPS 精度阈值（米）",
  "admin.guardId": "警卫编号：",
  "admin.loadingDirectory": "正在加载警卫名录…",
  "admin.moreCheckpoints": "另有 {n} 个检查点",
  "admin.noGuards": "未找到警卫。添加您的第一名警卫即可开始。",
  "admin.noRoutesAssigned": "未分配路线",
  "admin.notGenerated": "未生成",
  "admin.passwordPolicy": "密码策略",
  "admin.passwordPolicyDesc": "强制使用强密码",
  "admin.patrolRoutes": "巡逻路线",
  "admin.placeholderTempPassword": "设置临时密码",
  "admin.resetSessions": "重置所有会话",
  "admin.roleAdmin": "管理员",
  "admin.roleDirector": "总监",
  "admin.roleGuard": "警卫",
  "admin.roleSupervisor": "主管",
  "admin.saveConfiguration": "保存配置",
  "admin.searchGuards": "搜索警卫…",
  "admin.securitySettings": "安全设置",
  "admin.sessionTimeout": "会话超时",
  "admin.sessionTimeoutDesc": "无操作后自动注销",
  "admin.statusDeactivated": "已停用",
  "admin.statusLabel": "状态：",
  "admin.statusSuspended": "已暂停",
  "admin.storageUsed": "已用存储",
  "admin.systemConfiguration": "系统配置",
  "admin.systemStatus": "系统状态",
  "admin.tabBadges": "工牌生成器",
  "admin.tabGuards": "警卫管理",
  "admin.tabRoutes": "巡逻路线管理",
  "admin.tabSettings": "系统设置",
  "admin.timeout1Hour": "1 小时",
  "admin.timeout2Hours": "2 小时",
  "admin.timeout30Min": "30 分钟",
  "admin.timeout4Hours": "4 小时",
  "admin.totalScans": "扫描总数",
  "admin.twoFactor": "双重身份验证",
  "admin.twoFactorDesc": "要求所有主管启用双重验证",
  "admin.viewBadge": "查看工牌",
  "alerts.acknowledged": "已确认",
  "alerts.activeAlerts": "活动警报",
  "alerts.allLocationsHealthy": "所有地点状态正常",
  "alerts.allPriorities": "所有优先级",
  "alerts.allStatus": "所有状态",
  "alerts.allTypes": "所有类型",
  "alerts.apiError": "API 错误",
  "alerts.assignedTo": "分配给：",
  "alerts.critical": "严重",
  "alerts.distanceAway": "{n} 米外",
  "alerts.exportTitle": "导出警报数据",
  "alerts.filters": "筛选",
  "alerts.guardLabel": "保安 {name}",
  "alerts.high": "高",
  "alerts.invalidScan": "无效扫描",
  "alerts.issuesDetected": "检测到 {n} 个问题",
  "alerts.loadFailed": "加载警报失败",
  "alerts.loadFailedHint": "请检查警报接口是否已部署。",
  "alerts.loadingAlerts": "正在加载警报...",
  "alerts.low": "低",
  "alerts.medium": "中",
  "alerts.noInvalidScans": "最新批次中没有无效扫描。",
  "alerts.noneMatchFilters": "没有符合筛选条件的警报",
  "alerts.refreshTitle": "刷新警报",
  "alerts.resolved": "已解决",
  "alerts.scanExceptions": "巡逻扫描异常",
  "alerts.scanExceptionsSubtitle": "来自现场设备的无效扫描或 API 错误",
  "alerts.tryAgain": "重试",
  "alerts.typeEmergency": "紧急",
  "alerts.typeMissedCheckpoint": "漏检查点",
  "alerts.typeSystem": "系统",
  "alerts.unknownGuard": "未知",
  "ask.accessDenied": "拒绝访问",
  "ask.accessDeniedDesc": "“询问 AI”功能仅限管理员使用。",
  "ask.askNow": "立即提问",
  "ask.askedTimesOne": "已提问 {n} 次",
  "ask.askedTimesOther": "已提问 {n} 次",
  "ask.closeHistory": "关闭历史记录",
  "ask.dateAtTime": "{date} {time}",
  "ask.encryptedPrivate": "加密私密分析",
  "ask.errorMessage": "抱歉，我无法处理该问题。这可能是由于连接问题或不受支持的查询所致。请尝试重新表述您的问题，或稍后再试。",
  "ask.exampleInvalidScans": "本周哪些地点记录的无效扫描最多？",
  "ask.exampleMissedScans": "显示过去 7 天内漏扫 3 次或以上的警卫。",
  "ask.exampleNoScansToday": "列出今天没有收到任何扫描的地点。",
  "ask.exampleOvernightScans": "夜间 22:00 至 06:00 之间记录了多少次扫描？",
  "ask.frequentlyAsked": "常见问题",
  "ask.hideSql": "隐藏 SQL 查询",
  "ask.history": "历史记录",
  "ask.inputPlaceholder": "提问例如“昨天哪些地点的扫描次数最少？”",
  "ask.noHistory": "暂无历史记录。提出一个问题即可开始。",
  "ask.noQueriesMatching": "没有与“{q}”匹配的查询",
  "ask.rowCountOne": "{n} 行",
  "ask.rowCountOther": "{n} 行",
  "ask.searchPlaceholder": "搜索历史查询...",
  "ask.showSql": "显示 SQL 查询",
  "ask.subtitle": "询问巡逻合规情况、漏检的检查点、警卫表现或地点趋势。",
  "ask.tagline": "基于实时巡逻数据",
  "ask.thisWeek": "本周",
  "ask.today": "今天",
  "ask.yesterday": "昨天",
  "auth.applyToJoin": "申请加入我们的团队",
  "auth.email": "电子邮件",
  "auth.enterCredentials": "输入您的凭据以访问系统。",
  "auth.needAccess": "需要访问安防系统吗？",
  "deploy.addFloor": "+ 楼层",
  "deploy.addUnplannedCheckpoint": "添加计划外检查点",
  "deploy.address": "地址",
  "deploy.allSaved": "全部已保存",
  "deploy.area": "区域",
  "deploy.areaDescription": "区域 / 描述",
  "deploy.areaLabel": "区域：",
  "deploy.areaPlaceholder": "急诊入口、行政套房 200…",
  "deploy.areaSuite": "区域 / 套房",
  "deploy.cameraError": "摄像头错误：",
  "deploy.cancelScan": "取消扫描",
  "deploy.captureWalkthrough": "采集巡查",
  "deploy.capturedProgress": "已采集 {done} / {total}",
  "deploy.checkpointsCount": "检查点 ({n})",
  "deploy.ckStatusCaptured": "已采集",
  "deploy.ckStatusInstalled": "已安装",
  "deploy.ckStatusPlanned": "已规划",
  "deploy.ckStatusVerified": "已验证",
  "deploy.clickAnywhereToPlace": "点击任意位置放置标记",
  "deploy.clickFloorPlan": "点击楼层平面图…",
  "deploy.complete": "已完成！",
  "deploy.completionReport": "完成报告",
  "deploy.contactLabel": "联系人：",
  "deploy.contactPhone": "联系电话",
  "deploy.createAndCapture": "创建并采集",
  "deploy.createProject": "创建项目",
  "deploy.creating": "正在创建…",
  "deploy.dismiss": "忽略",
  "deploy.editingCheckpoint": "正在编辑检查点",
  "deploy.fileFormats": "PNG、JPG 或 PDF",
  "deploy.floor": "楼层",
  "deploy.floorColon": "楼层：",
  "deploy.floorLabel": "楼层：",
  "deploy.floorN": "{n} 楼",
  "deploy.floorPlanAlt": "{n} 楼平面图",
  "deploy.generated": "生成时间：",
  "deploy.gettingGps": "正在获取 GPS…",
  "deploy.gpsFailedRetry": "GPS 失败 — 重试",
  "deploy.grabGps": "获取 GPS",
  "deploy.hospitalNameRequired": "医院名称 *",
  "deploy.initials": "签名缩写：______",
  "deploy.installVerify": "安装与验证",
  "deploy.installedAlt": "已安装",
  "deploy.installedVerifiedProgress": "已安装并验证 {done} / {total}",
  "deploy.locationDetail": "位置详情",
  "deploy.locationDetailPlaceholder": "正门左侧，洗手液上方…",
  "deploy.locationDetailShort": "正门左侧…",
  "deploy.locationLabel": "位置：",
  "deploy.markInstalledVerified": "标记为已安装并验证",
  "deploy.newCheckpoint": "新检查点",
  "deploy.newDeploymentProject": "新建部署项目",
  "deploy.newProject": "新建项目",
  "deploy.newUnplannedCheckpoint": "新建计划外检查点",
  "deploy.noCameraFound": "未找到摄像头",
  "deploy.noCheckpointsHint": "点击“放置标记”，然后点击楼层平面图。",
  "deploy.noCheckpointsYet": "暂无检查点。",
  "deploy.noProjectSelected": "未选择项目",
  "deploy.noProjectSelectedHint": "请在上方选择现有项目或创建新项目。",
  "deploy.noProjectsYet": "暂无项目。",
  "deploy.notYetVerified": "尚未验证",
  "deploy.notes": "备注",
  "deploy.notesLabel": "备注：",
  "deploy.notesPlaceholder": "地标备注、安装细节…",
  "deploy.placeCardHere": "将卡片放在此处（来自采集）：",
  "deploy.placeMarker": "放置标记",
  "deploy.placementNotes": "放置备注",
  "deploy.placementNotesPlaceholder": "高 1.5 米，砖墙，永久性粘合剂…",
  "deploy.placementReferenceAlt": "放置参考",
  "deploy.print": "打印",
  "deploy.printChecklist": "打印检查清单",
  "deploy.qrPlaced": "二维码已放置",
  "deploy.qrPrefix": "二维码：",
  "deploy.recapture": "重新采集",
  "deploy.retakeInstalledPhoto": "重新拍摄安装照片",
  "deploy.retakePhoto": "重新拍照",
  "deploy.reverify": "重新验证",
  "deploy.saveCapture": "保存采集",
  "deploy.scanAgain": "再次扫描",
  "deploy.scanQrCode": "扫描二维码",
  "deploy.scanToVerify": "扫描以验证",
  "deploy.scanVerified": "扫描已验证",
  "deploy.scannedPrefix": "已扫描：",
  "deploy.selectProject": "选择一个项目…",
  "deploy.selectProjectShort": "选择项目…",
  "deploy.selectProjectToCapture": "选择一个项目开始采集。",
  "deploy.selectProjectToVerify": "选择一个项目开始验证。",
  "deploy.simulation3d": "3D 模拟",
  "deploy.siteContactName": "现场联系人姓名",
  "deploy.speechNotSupported": "此浏览器不支持语音识别。",
  "deploy.statusCapturing": "采集中",
  "deploy.statusComplete": "已完成",
  "deploy.statusFabricating": "制作中",
  "deploy.statusInstalling": "安装中",
  "deploy.statusPlanning": "规划中",
  "deploy.stop": "站点",
  "deploy.stopNumber": "站点 #{n}",
  "deploy.stopVoice": "停止",
  "deploy.takeInstalledPhoto": "拍摄安装照片",
  "deploy.takePhoto": "拍照",
  "deploy.total": "总计",
  "deploy.unnamed": "未命名",
  "deploy.unnamedLower": "未命名",
  "deploy.unsavedChanges": "有未保存的更改…",
  "deploy.uploadFloorPlan": "上传楼层平面图",
  "deploy.uploadFloorPlanFor": "为 {n} 楼上传楼层平面图",
  "deploy.uuidMatched": "UUID 匹配！二维码已验证。",
  "deploy.uuidMismatch": "UUID 不匹配。二维码卡片错误。",
  "deploy.uuidPrefix": "UUID：",
  "deploy.verifiedCheckpoints": "已验证的检查点",
  "deploy.verifiedCount": "已验证",
  "deploy.voice": "语音",
  "deploy.walkthroughChecklistStops": "部署巡查检查清单 — {n} 个站点",
  "devices.appVersion": "应用版本",
  "devices.deviceManagement": "设备管理",
  "devices.emptyHint": "已连接的设备发送遥测数据后将显示在此处。",
  "devices.geofences": "地理围栏",
  "devices.hoursAgo": "{n} 小时前",
  "devices.justNow": "刚刚",
  "devices.lastLocation": "最后位置",
  "devices.locateOnMap": "在地图上定位设备",
  "devices.minutesAgo": "{n} 分钟前",
  "devices.never": "从不",
  "devices.noDevicesFound": "未找到设备",
  "devices.noGpsData": "无 GPS 数据",
  "devices.refreshStatus": "刷新状态",
  "devices.violations": "违规",
  "geofence.acknowledge": "确认",
  "geofence.acknowledged": "已确认",
  "geofence.acknowledging": "正在确认…",
  "geofence.actionHeader": "操作",
  "geofence.allGeofences": "所有地理围栏",
  "geofence.create": "创建地理围栏",
  "geofence.createdBy": "创建者",
  "geofence.createdDate": "创建日期",
  "geofence.deleteConfirmBody": "此操作无法撤销。地理围栏将被永久删除。",
  "geofence.deleteConfirmTitle": "删除地理围栏？",
  "geofence.drawPolygon": "在地图上绘制多边形",
  "geofence.drawPolygonHint": "点击地图添加点。多边形必须至少有 3 个点。当前点数：{n}",
  "geofence.edit": "编辑地理围栏",
  "geofence.enterName": "请输入地理围栏名称",
  "geofence.failedCreate": "创建地理围栏失败",
  "geofence.failedDelete": "删除地理围栏失败",
  "geofence.failedLoad": "加载地理围栏失败",
  "geofence.failedSave": "保存地理围栏失败",
  "geofence.failedUpdate": "更新地理围栏失败",
  "geofence.filterByGeofence": "按地理围栏筛选",
  "geofence.geofenceHeader": "地理围栏",
  "geofence.gpsCoordinates": "GPS 坐标",
  "geofence.hoursAgo": "{n} 小时前",
  "geofence.justNow": "刚刚",
  "geofence.management": "地理围栏管理",
  "geofence.managementSubtitle": "定义安全区域并监控边界违规",
  "geofence.minPoints": "多边形必须至少有 3 个点",
  "geofence.minutesAgo": "{n} 分钟前",
  "geofence.nameLabel": "地理围栏名称",
  "geofence.namePlaceholder": "例如：正门、停车场 A",
  "geofence.noViolations": "未检测到违规",
  "geofence.noViolationsHint": "所有设备均位于其指定的地理围栏内。",
  "geofence.noneConfigured": "您的位置未配置任何地理围栏。",
  "geofence.noneYet": "暂无地理围栏",
  "geofence.noneYetCanCreate": "创建您的第一个地理围栏，开始边界监控。",
  "geofence.pointN": "点 {n}：",
  "geofence.polygonPoints": "多边形点 ({n})",
  "geofence.preview": "预览",
  "geofence.save": "保存地理围栏",
  "geofence.selectHospitalAlert": "请选择一家医院",
  "geofence.selectHospitalOption": "选择一家医院…",
  "geofence.unacknowledged": "未确认",
  "geofence.unacknowledgedCount": "{n} 项未确认",
  "geofence.violationsSubtitle": "监控并确认边界违规",
  "geofence.violationsTitle": "地理围栏违规",
  "help.callNow": "立即致电",
  "help.comingSoon": "即将推出",
  "help.docsComingSoon": "文档即将推出。",
  "help.emailSupport": "电子邮件支持",
  "help.escalateIssue": "升级问题",
  "help.guardHeadline": "警卫帮助与支持",
  "help.guidesFaq": "指南与常见问题",
  "help.incidentEscalation": "事件升级",
  "help.incidentEscalationDesc": "报告停机、自助终端故障或紧急扫描问题。",
  "help.intro": "联系 Emory 安全巡逻团队或查看快速故障排除步骤。",
  "help.phoneHotline": "电话热线",
  "help.phoneHotlineValue": "(404) 555-0199 • 全天候",
  "help.quickTips": "快速提示",
  "help.sendEmail": "发送电子邮件",
  "help.supervisorHeadline": "主管帮助与支持",
  "help.support": "支持",
  "help.tipAskAi": "在联系支持之前，使用“询问 AI”页面调取历史数据。",
  "help.tipRefresh": "如果扫描结果出现延迟或过时，请刷新页面。",
  "help.tipReinstall": "当图标消失时，警卫可以通过“设置”页面重新安装 PWA。",
  "home.activeCheckpoints": "活动检查点",
  "home.activeCheckpointsTooltip": "本医院当前注册的实体二维码位置总数。",
  "home.addNewMarker": "添加新标记",
  "home.allHospitalsAggregated": "所有医院（汇总）",
  "hospitals.allAggregated": "所有医院（汇总）",
  "home.building": "建筑",
  "home.buildingFloor": "{building} - {floor}层",
  "home.cancelPlacement": "取消放置",
  "home.chartScans": "扫描次数：",
  "home.checkpointName": "检查点名称",
  "home.checkpointNamePlaceholder": "例如：财务（西区）",
  "home.checkpointsScanned": "已扫描检查点",
  "home.chooseCheckpoint": "— 选择一个检查点 —",
  "home.cleared": "已清除",
  "home.clickToPlace": "点击地图上的任意位置以放置新标记。",
  "home.comparingScanVolume": "对比所有已注册站点的活跃扫描量",
  "home.complianceRate": "合规率",
  "home.complianceRateTooltip": "在当前班次期间至少被扫描一次的已注册检查点的百分比。",
  "home.complianceRateValue": "合规率：{n}%",
  "home.confirmDeleteCheckpoint": "确定要删除此检查点吗？此操作无法撤销。",
  "home.createCustomCheckpoint": "+ 创建自定义检查点…",
  "home.deleteMarker": "删除标记",
  "home.dragToReposition": "拖动标记以重新定位。更改将自动保存。",
  "home.editModeOn": "编辑模式开启",
  "home.editPositions": "编辑位置",
  "home.failedDeleteLocation": "删除位置失败",
  "home.failedSaveLocation": "保存位置失败",
  "home.floor": "楼层",
  "home.floorAbbr": "{n}层",
  "home.floorN": "{n}层",
  "home.headerSubtitle": "实时巡逻验证和集线器上传状态",
  "home.hospitalPerformanceComparison": "医院绩效对比",
  "home.hospitalSecurity": "医院安保",
  "home.hub": "集线器：{hub}",
  "home.internalServerError": "服务器内部错误",
  "home.lastHour": "最近一小时",
  "home.lastScan": "最后扫描",
  "home.lastUpdated": "最后更新：",
  "home.legendError": "错误",
  "home.legendInvalid": "无效",
  "home.legendOk": "正常",
  "home.liveSystem": "实时系统",
  "home.loadingCheckpoints": "正在加载检查点…",
  "home.loadingComplianceData": "正在加载合规数据…",
  "home.loadingUploads": "正在加载上传…",
  "home.mapLast30Days": "过去 30 天",
  "home.mapLast7Days": "过去 7 天",
  "home.mapLastQuarter": "上一季度",
  "home.mapSubtitle": "实时巡逻跟踪和检查点状态",
  "home.mapTitle": "医院实时活动地图",
  "home.mapTodaysScans": "今日扫描",
  "home.moreCheckpoints": "+ 另外 {n} 个检查点",
  "home.noCheckpointsConfigured": "本医院尚未配置检查点。",
  "home.noCheckpointsLoaded": "未加载任何检查点。请检查数据库连接，或在下方手动添加。",
  "home.noUploadsToday": "今天没有记录任何上传。",
  "home.numberOfScans": "扫描次数",
  "home.pendingClear": "待清除",
  "home.placeCheckpoint": "放置检查点",
  "home.positionLabel": "位置：",
  "home.qrPayload": "二维码数据",
  "home.qrPayloadPlaceholder": "例如：FINANCE_WEST",
  "home.recentPatrolActivity7Days": "近期巡逻活动（7&nbsp;天）",
  "home.recentScans7Days": "近期扫描（7&nbsp;天）",
  "home.recentScansTooltip": "过去 7 天内成功上传并验证的巡逻扫描总数。",
  "home.registeredCheckpoints": "已注册检查点",
  "home.roleDashboard": "{role}仪表板：",
  "home.saveCheckpoint": "保存检查点",
  "home.scanner": "扫描仪：{serial}",
  "home.scansCount": "{n} 次扫描",
  "home.selectCheckpoint": "选择检查点",
  "home.tooltipPosition": "位置",
  "home.unknownHospital": "未知医院",
  "home.uploadsByShift": "按班次上传",
  "home.viewingHospital": "查看医院：",
  "landing.addressInfo": "地址信息",
  "landing.agreeTerms": "我同意服务条款",
  "landing.agreeTermsDetail": "我理解访问安保巡逻系统须经主管批准，并且所提供的所有信息均准确完整。",
  "landing.availableShifts": "可用班次（选择所有适用项）",
  "landing.bulletIntegrity": "针对漏扫和标记事件的完整性分析。",
  "landing.bulletMonitoring": "实时监控每个大堂、入口和走廊。",
  "landing.bulletWorkspace": "统一的主管工作区，支持即时搜索和 AI 洞察。",
  "landing.city": "城市",
  "landing.completeAndAgree": "请填写所有必填字段并同意条款。",
  "landing.confirmPassword": "确认密码",
  "landing.confirmYourPassword": "确认您的密码",
  "landing.createPassword": "创建一个安全的密码",
  "landing.dateOfBirth": "出生日期",
  "landing.emailAddress": "电子邮件地址",
  "landing.emailRegistered": "此电子邮件地址已注册。",
  "landing.emailRegisteredUseDifferent": "此电子邮件地址已注册。请使用其他电子邮件地址。",
  "landing.emergencyContact": "紧急联系人",
  "landing.emergencyContactName": "紧急联系人姓名",
  "landing.emergencyContactPhone": "紧急联系人电话",
  "landing.fillRequiredContinue": "请在继续之前填写所有必填字段。",
  "landing.firstName": "名字",
  "landing.lastName": "姓氏",
  "landing.next": "下一步",
  "landing.passwordsNoMatch": "密码不匹配",
  "landing.percentComplete": "已完成 {p}%",
  "landing.personalInfo": "个人信息",
  "landing.phoneNumber": "电话号码",
  "landing.phoneRegistered": "此电话号码已注册。",
  "landing.phoneRegisteredUseDifferent": "此电话号码已注册。请使用其他电话号码。",
  "landing.relChild": "子女",
  "landing.relFriend": "朋友",
  "landing.relOther": "其他",
  "landing.relParent": "父母",
  "landing.relSibling": "兄弟姐妹",
  "landing.relSpouse": "配偶",
  "landing.relationship": "关系",
  "landing.requestAccessSubtitle": "填写此表单以申请访问安保巡逻系统。",
  "landing.requestAccessTitle": "申请系统访问权限",
  "landing.requestSubmitted": "账户申请已提交",
  "landing.requestSubmittedApproval": "获批后，您即可使用凭据登录。此流程通常需要 1 至 2 个工作日。",
  "landing.requestSubmittedThanks": "感谢您申请访问安保巡逻系统。您的申请已提交，正在等待主管审批。",
  "landing.requestedRole": "申请的角色",
  "landing.returnHome": "返回首页",
  "landing.returnToLogin": "返回登录",
  "landing.roleAvailability": "角色与可用时间",
  "landing.securityDirector": "安保总监",
  "landing.securitySupervisor": "安保主管",
  "landing.selectEllipsis": "选择...",
  "landing.shiftDay": "白班（上午6点至下午2点）",
  "landing.shiftEvening": "晚班（下午2点至晚上10点）",
  "landing.shiftHolidays": "节假日",
  "landing.shiftNight": "夜班（晚上10点至上午6点）",
  "landing.shiftOnCall": "随叫随到",
  "landing.shiftWeekends": "周末",
  "landing.signInSubheading": "使用您的主管或警卫凭据继续。",
  "landing.signInToGuard": "登录 Guard",
  "landing.somethingWrong": "出现错误。",
  "landing.state": "州",
  "landing.stepOf": "第 {n} 步，共 4 步",
  "landing.streetAddress": "街道地址",
  "landing.submitApplication": "提交申请",
  "landing.submitFailed": "提交申请失败。请重试。",
  "landing.submitting": "正在提交...",
  "landing.termsOfService": "服务条款",
  "landing.zipCode": "邮政编码",
  "live.action": "操作",
  "live.activityFeed": "活动动态",
  "live.asOf": "截至 {time}",
  "live.colCoordinate": "坐标",
  "live.colDateTime": "日期和时间",
  "live.colDistance": "距离",
  "live.deviceLocation": "（设备位置）",
  "live.filterAll": "所有活动",
  "live.filterInvalid": "无效扫描",
  "live.filterValid": "有效扫描",
  "live.floor": "{n} 楼",
  "live.freshFix": "（实时定位）",
  "live.loadingActivity": "正在加载巡逻活动…",
  "live.metersAway": "距离 {n} 米",
  "live.noGpsData": "无 GPS 数据",
  "live.noScansFilter": "没有符合此筛选条件的扫描。",
  "live.syncData": "同步数据",
  "live.timeframe": "时间范围",
  "live.unknownHospital": "未知医院",
  "live.unknownLocation": "未知位置",
  "live.view3d": "3D 视图",
  "live.view3dWorld": "查看此检查点的 3D 世界",
  "map.allHospitals": "所有医院",
  "map.autoRefresh": "自动刷新",
  "map.autoRefreshTitle": "每 30 秒自动刷新",
  "map.dark": "深色",
  "map.expandLegend": "展开图例",
  "map.gpsDisclaimer": "扫描位置反映设备 GPS 精度。室内信号与实际位置可能相差 10–50 米。",
  "map.heatmap": "热力图",
  "map.heatmapTitle": "切换密度热力图",
  "map.legend": "图例",
  "map.light": "浅色",
  "map.limitedWarning": "地图最多显示 {max} 次扫描。请缩小时间范围或医院筛选条件以查看具体数据。",
  "map.loadFailed": "加载扫描失败",
  "map.loadingScans": "正在加载扫描…",
  "map.mapStyle": "地图样式：{name}",
  "map.markers": "标记",
  "map.minimizeLegend": "最小化图例",
  "map.noGpsScans": "在此时间范围内未找到带 GPS 标记的扫描。",
  "map.pageSubtitle": "扫描事件发生位置的实时地理视图。",
  "map.pageTitle": "GuardAI 扫描地图",
  "map.popupHospital": "医院：",
  "map.popupScanner": "扫描器：",
  "map.popupTime": "时间：",
  "map.rangeCustom": "自定义范围",
  "map.rangeLast24h": "最近 24 小时",
  "map.rangeLast30d": "最近 30 天",
  "map.rangeLast7d": "最近 7 天",
  "map.rangeLastHour": "最近一小时",
  "map.showingMaxScans": "显示 {total} 次扫描中的 {shown} 次（上限）",
  "map.snapToBuilding": "对齐到建筑",
  "map.snapToBuildingTitle": "将 GPS 点对齐到建筑中心，以抵消室内 GPS 漂移",
  "map.switchToDark": "切换到深色地图",
  "map.switchToLight": "切换到浅色地图",
  "map.to": "至",
  "map.totalScans": "{total} 次扫描",
  "map.unknownHospital": "未知",
  "map.updatedAt": "更新于 {time}",
  "reportBuilder.addWidget": "添加小部件",
  "reportBuilder.aiAssistant": "AI 报告助手",
  "reportBuilder.aiPlaceholder": "描述您想要的报告 — 例如“上个月各医院的扫描次数，用柱状图展示”。或在纸上画出布局并上传照片。",
  "reportBuilder.aiSummaryHint": "点击“生成”以根据报告数据撰写观察结论。",
  "reportBuilder.allHospitals": "所有医院",
  "reportBuilder.allTime": "全部时间",
  "reportBuilder.assistantUnavailable": "助手目前不可用。",
  "reportBuilder.author": "作者",
  "reportBuilder.beta": "测试版",
  "reportBuilder.buildItForMe": "为我生成",
  "reportBuilder.buildTogether": "我们一起来构建",
  "reportBuilder.canvasEmpty": "您的画布为空",
  "reportBuilder.canvasEmptyHint": "从上方工具栏添加小部件、点击左侧的数据字段，或从模板开始。",
  "reportBuilder.captionPlaceholder": "标题说明（可选）",
  "reportBuilder.color": "颜色",
  "reportBuilder.compareAgainst": "对比对象",
  "reportBuilder.configure": "配置",
  "reportBuilder.copySuffix": "（副本）",
  "reportBuilder.couldntSave": "无法保存：",
  "reportBuilder.dataFields": "数据字段",
  "reportBuilder.dataFieldsHint": "点击任意字段，将预建小部件添加到报告中。",
  "reportBuilder.dataSource": "数据源",
  "reportBuilder.dateFrom": "自 {date} 起",
  "reportBuilder.dateFromLabel": "起始日期",
  "reportBuilder.dateThrough": "截至 {date}",
  "reportBuilder.dateToLabel": "结束日期",
  "reportBuilder.dayOfWeekOpt": "星期",
  "reportBuilder.describeOrSketch": "描述您想要的报告，或附上草图。",
  "reportBuilder.dismiss": "忽略",
  "reportBuilder.done": "完成",
  "reportBuilder.donutStyle": "环形样式",
  "reportBuilder.draftedOffline": " · 离线起草",
  "reportBuilder.duplicate": "复制",
  "reportBuilder.example1": "上个月各医院的扫描次数，用柱状图展示",
  "reportBuilder.example2": "每日巡逻活动，含高峰时段和活跃设备",
  "reportBuilder.example3": "检查点覆盖率：各医院已扫描与未扫描对比",
  "reportBuilder.exportCsv": "CSV（数据）",
  "reportBuilder.exportFailed": "导出失败：",
  "reportBuilder.exportHtml": "HTML（可分享）",
  "reportBuilder.exportPdf": "PDF（可打印）",
  "reportBuilder.exportPng": "PNG 图像",
  "reportBuilder.exportPrint": "打印",
  "reportBuilder.exportSlides": "可用于幻灯片 (HTML)",
  "reportBuilder.exportTryPdf": "请改用 PDF（打印）。",
  "reportBuilder.exportXls": "Excel (.xls)",
  "reportBuilder.fieldTitle": "标题",
  "reportBuilder.filterFloor": "筛选：楼层",
  "reportBuilder.filterHospital": "筛选：医院",
  "reportBuilder.floorPlaceholder": "例如 L1、5、Plaza",
  "reportBuilder.generate": "生成",
  "reportBuilder.generateBtn": "生成",
  "reportBuilder.generatedBy": "由 GuardAI 生成 · © {year} G-Data Labs。保留所有权利。",
  "reportBuilder.generating": "生成中…",
  "reportBuilder.group": "分组",
  "reportBuilder.groupBy": "分组依据",
  "reportBuilder.hideSettings": "隐藏设置",
  "reportBuilder.horizontal": "水平",
  "reportBuilder.imageTooLarge": "该图片有点大 — 请使用小于 6 MB 的图片。",
  "reportBuilder.imageUrlPlaceholder": "图片网址（可选）",
  "reportBuilder.includeLogo": "包含 GuardAI 徽标",
  "reportBuilder.loadFailed": "无法加载数据。",
  "reportBuilder.lookAt": "请看 {target}",
  "reportBuilder.maxRows": "最大行数",
  "reportBuilder.metric": "指标",
  "reportBuilder.moreSettings": "更多设置",
  "reportBuilder.moveDown": "下移",
  "reportBuilder.moveUp": "上移",
  "reportBuilder.next": "下一步",
  "reportBuilder.noDataSelection": "此选择没有数据",
  "reportBuilder.noImageUploaded": "未上传图片",
  "reportBuilder.noLayout": "我无法将其转换为布局 — 请尝试描述指标以及如何分组。",
  "reportBuilder.noSummary": "未生成摘要。",
  "reportBuilder.noWidgetsYet": "此报告尚无小部件。",
  "reportBuilder.optionalSubtitle": "可选副标题",
  "reportBuilder.orientation": "方向",
  "reportBuilder.period": "时段：{range}",
  "reportBuilder.preparedBy": "编制人：{name}",
  "reportBuilder.preview": "预览",
  "reportBuilder.previewHint": "这是您的报告导出和打印的效果。使用上方的“导出”按钮进行下载。",
  "reportBuilder.regenerate": "重新生成",
  "reportBuilder.remove": "移除",
  "reportBuilder.removeImage": "移除图片",
  "reportBuilder.reportImage": "报告图片",
  "reportBuilder.reportTitle": "报告标题",
  "reportBuilder.reportsAnalytics": "报告与分析",
  "reportBuilder.saveAsTemplate": "将当前报告保存为共享模板",
  "reportBuilder.savedAt": "已于 {time} 保存",
  "reportBuilder.savedReports": "已保存的报告",
  "reportBuilder.secondSeriesLabel": "第二系列标签",
  "reportBuilder.secondSeriesMetric": "第二系列指标",
  "reportBuilder.secondSeriesSource": "第二系列数据源",
  "reportBuilder.selectWidget": "选择一个小部件进行配置。",
  "reportBuilder.seriesB": "系列 B",
  "reportBuilder.sketch": "草图",
  "reportBuilder.sketchAlt": "草图",
  "reportBuilder.sort": "排序",
  "reportBuilder.sortLabelAsc": "名称，A → Z",
  "reportBuilder.sortLabelDesc": "名称，Z → A",
  "reportBuilder.sortValueAsc": "数值，从低到高",
  "reportBuilder.sortValueDesc": "数值，从高到低",
  "reportBuilder.startFromTemplate": "从模板开始",
  "reportBuilder.startNewReport": "新建报告",
  "reportBuilder.stepOf": "第 {n} 步，共 {total} 步",
  "reportBuilder.subtitle": "副标题",
  "reportBuilder.summaryFailed": "生成摘要失败。",
  "reportBuilder.targetAiBar": "AI 助手栏",
  "reportBuilder.targetCanvas": "报告画布",
  "reportBuilder.targetConfigPanel": "配置面板",
  "reportBuilder.targetDataFields": "数据字段面板",
  "reportBuilder.targetExport": "“导出”按钮",
  "reportBuilder.targetPreview": "预览切换按钮",
  "reportBuilder.targetSave": "“保存”按钮",
  "reportBuilder.targetTemplates": "“模板”按钮",
  "reportBuilder.targetToolbar": "小部件工具栏",
  "reportBuilder.templates": "模板",
  "reportBuilder.textPlaceholder": "撰写您的文本。使用 ## 表示标题，**加粗** 表示强调。",
  "reportBuilder.thinking": "思考中…",
  "reportBuilder.title": "报告生成器",
  "reportBuilder.total": "合计",
  "reportBuilder.try": "试试：",
  "reportBuilder.untitledReport": "未命名报告",
  "reportBuilder.uploadSketchTitle": "上传手绘报告布局的照片",
  "reportBuilder.vertical": "垂直",
  "reportBuilder.walkMeThrough": "逐步引导我",
  "reportBuilder.widgetCountMany": "{n} 个小部件",
  "reportBuilder.widgetCountOne": "{n} 个小部件",
  "reportBuilder.width": "宽度",
  "reportBuilder.widthFull": "整宽",
  "reportBuilder.working": "处理中…",
  "reports.activeGuards": "在岗保安",
  "reports.asOfTime": "（截至 {time}）",
  "reports.averageCompliance": "平均合规率",
  "reports.averageResponseTime": "平均响应时间",
  "reports.checkpointLocationAnalysis": "检查点位置分析",
  "reports.checkpointsCompleted": "已完成检查点",
  "reports.checkpointsLoggedGps": "（根据 GPS 数据记录了 {n} 个检查点）",
  "reports.colCompliance": "合规率",
  "reports.colPerformance": "绩效",
  "reports.compliance90to94": "90-94% 合规",
  "reports.compliance95": "≥95% 合规",
  "reports.complianceBelow90": "<90% 合规",
  "reports.complianceLabel": "合规率",
  "reports.complianceReport": "合规报告",
  "reports.coverageComplianceHelp": "在此时间段内至少访问一次的检查点百分比",
  "reports.coverageComplianceTrends": "覆盖合规趋势",
  "reports.criticalIssuesResolved": "已解决的关键问题",
  "reports.currentTime": "当前：{time}",
  "reports.dayFri": "周五",
  "reports.dayFriday": "星期五",
  "reports.dayMon": "周一",
  "reports.dayMonday": "星期一",
  "reports.daySat": "周六",
  "reports.daySaturday": "星期六",
  "reports.daySun": "周日",
  "reports.daySunday": "星期日",
  "reports.dayThu": "周四",
  "reports.dayThursday": "星期四",
  "reports.dayTue": "周二",
  "reports.dayTuesday": "星期二",
  "reports.dayWed": "周三",
  "reports.dayWednesday": "星期三",
  "reports.deltaLastMonth": "较上月 +1.8%",
  "reports.deltaLastQuarter": "较上季度 +3.2%",
  "reports.deltaLastWeek": "较上周 +2.1%",
  "reports.deltaYesterday": "较昨天 +1.5%",
  "reports.downloadReport": "下载报告",
  "reports.exceptions": "异常",
  "reports.exportFormat": "导出格式",
  "reports.exportReport": "导出报告",
  "reports.guardPerformanceAnalysis": "保安绩效分析",
  "reports.heatmapCellTitle": "{location} - {label}：{pct}% 活动",
  "reports.lessActivity": "活动较少",
  "reports.loadingPatrolActivity": "正在加载巡逻活动…",
  "reports.locationAbbreviations": "位置缩写：",
  "reports.locationActivityHeatmap": "位置活动热力图",
  "reports.missedCheckpoints": "遗漏的检查点",
  "reports.missedCount": "遗漏 {n} 个",
  "reports.monFeb": "2月",
  "reports.monJan": "1月",
  "reports.monMar": "3月",
  "reports.monthN": "第 {n} 月",
  "reports.moreActivity": "活动较多",
  "reports.noChange": "无变化",
  "reports.noCoverageData": "暂无覆盖数据",
  "reports.noDataForPeriod": "该时段无数据",
  "reports.noScanLocations": "暂无二维码扫描位置",
  "reports.notAvailable": "不适用",
  "reports.overallComplianceRate": "总体合规率",
  "reports.patrolLocations": "巡逻地点",
  "reports.periodMonth": "本月",
  "reports.periodQuarter": "本季度",
  "reports.periodToday": "今天",
  "reports.periodWeek": "本周",
  "reports.popupCompliance": "合规率：",
  "reports.popupLast": "最近：",
  "reports.popupScans": "扫描次数：",
  "reports.qrScanLocations": "二维码扫描位置",
  "reports.quickExportOptions": "快速导出选项",
  "reports.realScanData": "真实扫描数据（过去 24 小时）",
  "reports.scanToSeeLocations": "扫描二维码以在地图上查看位置",
  "reports.scansCount": "{n} 次扫描",
  "reports.scansThisMonth": "本月 {n} 次扫描",
  "reports.scansThisQuarter": "本季度 {n} 次扫描",
  "reports.scansThisWeek": "本周 {n} 次扫描",
  "reports.scansToday": "今天 {n} 次扫描",
  "reports.tabCompliance": "合规",
  "reports.tabGuardPerformance": "保安绩效",
  "reports.tabLocationAnalysis": "位置分析",
  "reports.tabOverview": "概览",
  "reports.totalScans": "扫描总数",
  "reports.trackingLocationsGuards": "正在追踪 {locations} 个地点和 {guards} 名保安。",
  "reports.trendDaily": "每日绩效趋势",
  "reports.trendHourly": "每小时绩效趋势",
  "reports.trendMonthly": "每月绩效趋势",
  "reports.trendTooltip": "{pct}%（{n} 个地点）",
  "reports.trendWeekly": "每周绩效趋势",
  "reports.validated": "已验证",
  "reports.viewDetails": "查看详情",
  "reports.weekN": "第 {n} 周",
  "reports.weeklySummary": "每周摘要",
  "reports.wk1": "第1周",
  "reports.wk2": "第2周",
  "reports.wk3": "第3周",
  "reports.wk4": "第4周",
  "schedules.activeRoutes": "活动路线",
  "schedules.activeSchedules": "活动排班",
  "schedules.addNewSchedule": "添加新排班",
  "schedules.addSchedule": "添加排班",
  "schedules.assignedGuard": "指派的警卫",
  "schedules.assignedGuards": "指派的警卫",
  "schedules.calendar": "日历",
  "schedules.confirmDelete": "确定要删除此排班吗？",
  "schedules.coverageGaps": "覆盖空缺",
  "schedules.createSchedule": "创建排班",
  "schedules.dayFri": "周五",
  "schedules.dayMon": "周一",
  "schedules.daySat": "周六",
  "schedules.daySun": "周日",
  "schedules.dayThu": "周四",
  "schedules.dayTue": "周二",
  "schedules.dayWed": "周三",
  "schedules.daysOfWeek": "星期",
  "schedules.deleteSchedule": "删除排班",
  "schedules.editSchedule": "编辑排班",
  "schedules.endTime": "结束时间",
  "schedules.fillRequired": "请填写所有必填字段",
  "schedules.frequency": "频率",
  "schedules.frequencyCustom": "自定义",
  "schedules.frequencyDaily": "每日",
  "schedules.frequencyWeekly": "每周",
  "schedules.listView": "列表视图",
  "schedules.morningPatrol": "晨间巡逻",
  "schedules.nightShift": "夜班",
  "schedules.route": "路线",
  "schedules.scheduleName": "排班名称",
  "schedules.scheduleNamePlaceholder": "例如：晨间巡逻 - A栋",
  "schedules.selectGuard": "选择警卫",
  "schedules.selectRoute": "选择路线",
  "schedules.selectedCount": "已选择：{n} 个检查点",
  "schedules.startTime": "开始时间",
  "schedules.updateSchedule": "更新排班",
  "settings.browserDesc": "记录 UA 以监控设备完整性。",
  "settings.browserLabel": "浏览器",
  "settings.cameraDesc": "扫描二维码标签所需。如果被拒绝，请在系统设置中调整。",
  "settings.cameraPermission": "相机权限",
  "settings.deviceIdDesc": "每次扫描时存储指纹以符合审计要求。",
  "settings.deviceIdLabel": "设备 ID",
  "settings.email": "电子邮件",
  "settings.escalationAlerts": "升级警报",
  "settings.fullName": "全名",
  "settings.installPwa": "安装为 PWA",
  "settings.locationDesc": "每个检查点的 GPS 验证所需。",
  "settings.locationPermission": "位置权限",
  "settings.mobilePhone": "手机",
  "settings.notRegistered": "尚未注册",
  "settings.notificationDesc": "控制主管团队可以向您发送哪些警报。",
  "settings.notificationPreferences": "通知偏好",
  "settings.permGranted": "已授予",
  "settings.permUnknown": "未知",
  "settings.profileDetails": "个人资料详情",
  "settings.profileSavedMsg": "个人资料偏好已保存。更改立即生效。",
  "settings.pwaAndroid": "Android（Chrome）：",
  "settings.pwaAndroidSteps": "菜单 →“安装应用”。",
  "settings.pwaDesktop": "桌面端：",
  "settings.pwaDesktopSteps": "使用地址栏中的浏览器安装提示。",
  "settings.pwaIos": "iOS（Safari）：",
  "settings.pwaIosSteps": "点按“分享”→“添加到主屏幕”。",
  "settings.saveProfile": "保存个人资料",
  "settings.storedLocally": "在个人资料同步可用之前，设置将存储在本地。",
  "settings.weeklyEmailSummary": "每周电子邮件摘要",
  "users.applicationDetails": "申请详情",
  "users.applicationReview": "申请审核：",
  "users.applicationStatus": "申请状态",
  "users.approve": "批准",
  "users.approveApplication": "批准申请",
  "users.backToApplications": "返回申请列表",
  "users.colApplicant": "申请人",
  "users.colRole": "角色",
  "users.dateAdded": "添加日期",
  "users.directoryFound": "在 employees_personal_info 表中找到。",
  "users.directoryMatch": "目录匹配",
  "users.directoryName": "目录名称",
  "users.email": "电子邮件",
  "users.filterAll": "所有申请",
  "users.filterPending": "待审核",
  "users.nextSteps": "后续步骤",
  "users.noApplications": "未找到申请",
  "users.phone": "电话",
  "users.phoneNumber": "电话号码",
  "users.reject": "拒绝",
  "users.rejectApplication": "拒绝申请",
  "users.requestedRole": "申请角色",
  "users.review": "审核",
  "users.statusRejected": "已拒绝",
  "users.stepBackgroundCheck": "启动背景调查",
  "users.stepCheckLicense": "检查执照/证书有效性",
  "users.stepScheduleInterview": "若批准则安排面试",
  "users.stepVerifyReferences": "通过电话核实推荐人",
  "users.submitted": "提交时间：",
  "widget.aiSummary": "AI 摘要",
  "widget.barChart": "柱状图",
  "widget.comparison": "对比",
  "widget.dataTable": "数据表",
  "widget.dayOfWeek": "星期",
  "widget.image": "图片",
  "widget.kpiRow": "KPI 行",
  "widget.lineChart": "折线图",
  "widget.metricCard": "指标卡片",
  "widget.pieDonut": "饼图 / 环形图",
  "widget.rankedTable": "排名表",
  "widget.textBlock": "文本块",

  // Activity calendar
  "calendar.title": "巡逻活动日历",
  "calendar.subtitle": "按天查看每个检查点的扫描活动",
  "calendar.viewMonth": "月",
  "calendar.viewWeek": "周",
  "calendar.viewDay": "日",
  "calendar.viewList": "列表",
  "calendar.today": "今天",
  "calendar.allHospitals": "所有医院",
  "calendar.totalScans": "{n} 次扫描",
  "calendar.activeDays": "{n} 个活跃日",
  "calendar.alertsCount": "{n} 条警报",
  "calendar.noActivityRange": "此期间没有扫描活动。",
  "calendar.loading": "正在加载活动…",
  "calendar.loadFailed": "加载活动失败",
  "calendar.refresh": "刷新",
  "calendar.colTime": "时间",
  "calendar.colHospital": "医院",
  "calendar.colCheckpoint": "检查点",
  "calendar.colDevice": "设备",
  "calendar.colGuard": "警卫",
  "calendar.violation": "违规",
  "calendar.violationsCount": "{n} 次违规",
  "calendar.scansShort": "{n} 次扫描",
  "calendar.hospitalsActive": "{n} 家医院活跃",
  "calendar.moreEvents": "另外 {n} 项",
  "calendar.weekOf": "{date} 当周",
  "calendar.dayEvents": "扫描事件",
  "calendar.hourlyDistribution": "每小时分布",
  "calendar.legendLess": "较少",
  "calendar.legendMore": "较多",
  "calendar.unknownHospital": "未知医院",
  "calendar.unknownGuard": "未知警卫",
  "calendar.unknownCheckpoint": "未知检查点",

  // --- Synced from en.ts: newer pages (officers, compliance, checkpoints, patrol reports) ---
  "nav.compliance": "合规",
  "nav.officers": "保安员",
  "nav.patrolReports": "巡逻报告",
  "common.retry": "重试",
  "common.collapse": "收起",
  "common.expand": "展开",
  "home.comparisonVsMapNote": "统计包含每一次已记录的扫描。扫描地图仅绘制带 GPS 坐标的扫描，因此其总数可能更低。",
  "live.colOfficer": "保安员",
  "live.unattributed": "未归属",
  "map.trailNote": "圆点按扫描时间着色。扫描之间不绘制路径——仅显示已记录的扫描位置。",
  "checkpoints.directoryTitle": "检查点目录",
  "checkpoints.directorySubtitle": "所有已注册的 QR 检查点，按楼层组织",
  "checkpoints.searchPlaceholder": "按名称、代码或建筑搜索…",
  "checkpoints.countShown": "{n} 个检查点",
  "checkpoints.exportCsv": "导出 CSV",
  "checkpoints.loadingDirectory": "正在加载检查点…",
  "checkpoints.empty": "未找到本医院的检查点。",
  "checkpoints.noFloor": "未分配",
  "checkpoints.floorLabel": "{n} 楼",
  "checkpoints.colCode": "代码",
  "checkpoints.colName": "名称",
  "checkpoints.colBuilding": "建筑",
  "checkpoints.colFloor": "楼层",
  "checkpoints.colLastScanned": "最后扫描",
  "checkpoints.colTotalScans": "扫描总数",
  "checkpoints.colStatus": "状态",
  "checkpoints.active": "活跃",
  "checkpoints.inactive": "未活跃",
  "checkpoints.never": "从不",
  "checkpoints.untitled": "未命名检查点",
  "checkpoints.totalScans": "扫描总数",
  "checkpoints.compliance": "合规率",
  "checkpoints.late": "延迟",
  "checkpoints.missed": "漏检",
  "checkpoints.fromDate": "起始",
  "checkpoints.toDate": "结束",
  "checkpoints.clearDates": "清除",
  "checkpoints.loadingHistory": "正在加载扫描历史…",
  "checkpoints.noScans": "所选范围内未记录此检查点的扫描。",
  "checkpoints.unknownDevice": "未知设备",
  "checkpoints.noGps": "无 GPS",
  "checkpoints.statusOnTime": "准时",
  "checkpoints.statusLate": "延迟",
  "checkpoints.statusMissed": "漏检",
  "checkpoints.viewHistory": "查看扫描历史",
  "compliance.title": "巡逻合规",
  "compliance.subtitle": "检查点扫描状态，对照各位置配置的间隔。",
  "compliance.advisory": "仅供参考。此视图显示每个检查点的最后扫描时间及其扫描间隔的剩余时间。它不是工作分配、巡逻路线或指令。扫描哪些检查点以及扫描顺序，仍由保安员及其主管决定，须遵从其雇主的岗位规定和任何更高优先级的职责。",
  "compliance.loadFailed": "无法加载合规状态",
  "compliance.overdue": "逾期",
  "compliance.overdueSub": "已超过扫描间隔",
  "compliance.dueSoon": "即将到期",
  "compliance.dueSoonSub": "处于间隔的最后四分之一",
  "compliance.onInterval": "间隔内",
  "compliance.onIntervalSub": "已在间隔内扫描",
  "compliance.neverScanned": "无扫描记录",
  "compliance.neverScannedSub": "不计为逾期",
  "compliance.neverScannedNoteTitle": "为何这些不计为逾期：",
  "compliance.neverScannedNote": "没有扫描记录的检查点没有可超过的间隔。在站点的历史数据回填运行之前，早于合规跟踪的检查点都会显示为此状态，因此将它们视为逾期会同时为每个检查点触发警报。",
  "compliance.openAlerts": "未处理合规警报",
  "compliance.checkpointStatus": "检查点状态",
  "compliance.filterAttention": "逾期及即将到期",
  "compliance.filterOverdue": "仅逾期",
  "compliance.filterAll": "所有检查点",
  "compliance.emptyAll": "未找到符合此选择的检查点。",
  "compliance.emptyAttention": "没有检查点逾期或即将到期。",
  "compliance.colCheckpoint": "检查点",
  "compliance.colStatus": "状态",
  "compliance.colLastScan": "最后扫描",
  "compliance.colInterval": "间隔",
  "compliance.colRemaining": "间隔剩余时间",
  "compliance.colScans24h": "扫描次数（24 小时）",
  "compliance.status.OVERDUE": "逾期",
  "compliance.status.DUE_SOON": "即将到期",
  "compliance.status.OK": "间隔内",
  "compliance.status.NEVER_SCANNED": "无扫描记录",
  "compliance.minutesShort": "分钟",
  "compliance.perDay": "每天",
  "compliance.ruleLocation": "位置规则",
  "compliance.ruleHospital": "站点默认",
  "compliance.truncated": "仅显示最紧急的结果。按站点缩小范围以查看其余部分。",
  "compliance.generatedAt": "状态截至",
  "compliance.rules": "扫描间隔",
  "compliance.rulesTitle": "扫描间隔",
  "compliance.rulesSubtitle": "位置规则覆盖站点默认值，站点默认值覆盖系统默认值。",
  "compliance.rulesEmpty": "无自定义规则——适用系统默认值。",
  "compliance.rulesLoadFailed": "无法加载规则",
  "compliance.rulesSaveFailed": "无法保存规则",
  "compliance.rulesDeleteFailed": "无法删除规则",
  "compliance.rulesCreateFailed": "无法创建规则",
  "compliance.rulesInvalid": "间隔和每日最小值必须为数字",
  "compliance.systemDefault": "系统默认值",
  "compliance.systemDefaultValue": "每",
  "compliance.systemDefaultNote": "没有自身规则的站点以此为衡量标准。",
  "compliance.siteWide": "此站点的所有检查点",
  "compliance.colAppliesTo": "适用于",
  "compliance.colIntervalMin": "间隔（分钟）",
  "compliance.colMinPerDay": "最少 / 24 小时",
  "compliance.colActions": "操作",
  "compliance.addSiteDefault": "添加站点默认值",
  "compliance.pickSiteToAdd": "选择单个站点以为其添加默认值。",
  "officers.title": "保安员",
  "officers.subtitle": "使用 N 号登录、以便其扫描得到归属的保安员。这些不是仪表板登录账户。",
  "officers.add": "添加保安员",
  "officers.addTitle": "添加保安员",
  "officers.editTitle": "编辑保安员",
  "officers.loadFailed": "无法加载保安员",
  "officers.saveFailed": "无法保存保安员",
  "officers.deactivateFailed": "无法停用保安员",
  "officers.searchPlaceholder": "按姓名、N 号或电子邮件搜索",
  "officers.filterActive": "活跃",
  "officers.filterInactive": "未活跃",
  "officers.filterSuspended": "已暂停",
  "officers.filterPending": "待审批",
  "officers.filterRejected": "已拒绝",
  "officers.filterAll": "所有状态",
  "officers.onShiftCount": "当前已登录：",
  "officers.empty": "暂无保安员。添加一名以开始归属扫描。",
  "officers.emptySearch": "没有符合该搜索的保安员。",
  "officers.colOfficer": "保安员",
  "officers.colNNumber": "N 号",
  "officers.colSite": "站点",
  "officers.colStatus": "状态",
  "officers.colShift": "当前班次",
  "officers.colActions": "操作",
  "officers.status.ACTIVE": "活跃",
  "officers.status.PENDING": "待审批",
  "officers.status.INACTIVE": "未活跃",
  "officers.status.SUSPENDED": "已暂停",
  "officers.status.REJECTED": "已拒绝",
  "officers.onShiftSince": "在岗自",
  "officers.offShift": "未登录",
  "officers.scans": "次扫描",
  "officers.deactivate": "停用",
  "officers.deactivateTitle": "停用保安员？",
  "officers.deactivateBody": "{name} 将无法再登录，任何未结束的班次都会关闭。其扫描历史将保留并仍归属于其本人。",
  "officers.fieldNNumber": "N 号",
  "officers.fieldNNumberHint": "如果省略，开头的 N 会自动添加。",
  "officers.fieldName": "全名",
  "officers.fieldSite": "站点",
  "officers.fieldEmail": "电子邮件",
  "officers.fieldPhone": "电话",
  "officers.fieldStatus": "状态",
  "officers.fieldStatusHint": "只有 ACTIVE 状态的保安员才能登录。从 ACTIVE 切换会关闭任何未结束的班次。",
  "officers.selectSite": "选择站点",
  "officers.formRequired": "N 号、姓名和站点为必填项",
  "officers.pendingTitle": "待处理的注册审批",
  "officers.selfEnrolled": "自助注册",
  "officers.enrolledAt": "登录于",
  "officers.enrollDistance": "距站点已记录的扫描区域 {d}",
  "officers.enrollNoGps": "登录时无 GPS 定位",
  "officers.enrollSiteMismatch": "已选择 {chosen}，但 GPS 指向 {gps}——审批前请确认哪个正确。",
  "officers.pendingNote": "这些身份是在胸牌扫描时自行填报的。其扫描会临时归属，直到获批为止；拒绝将保留记录及其扫描以供审查。",
  "officers.approve": "批准",
  "officers.reject": "拒绝",
  "officers.approveTitle": "批准注册？",
  "officers.approveBody": "确认 {n} 为 {site} 的保安员。其待处理的扫描将保持归属，未来登录将正常进行。",
  "officers.approveName": "保安员姓名（应显示的名称）",
  "officers.approveFailed": "无法批准注册",
  "officers.rejectFailed": "无法拒绝注册",
  "patrolReports.title": "巡逻报告",
  "patrolReports.subtitle": "按保安员记录的巡逻活动、检查点覆盖情况及合规警报历史。",
  "patrolReports.tabOfficers": "保安员",
  "patrolReports.tabCoverage": "覆盖情况",
  "patrolReports.tabHistory": "警报历史",
  "patrolReports.loadFailed": "无法加载报告",
  "patrolReports.badRange": "开始日期必须早于或等于结束日期",
  "patrolReports.startDate": "开始日期",
  "patrolReports.endDate": "结束日期",
  "patrolReports.totalScans": "时段内扫描",
  "patrolReports.attributed": "已归属保安员",
  "patrolReports.unattributed": "未归属",
  "patrolReports.unattributedSub": "无保安员登录时扫描",
  "patrolReports.officersListed": "列出的保安员",
  "patrolReports.noOfficers": "此选择中没有保安员。",
  "patrolReports.colOfficer": "保安员",
  "patrolReports.colSite": "站点",
  "patrolReports.colShifts": "班次",
  "patrolReports.colShiftTime": "班次时长",
  "patrolReports.colScans": "扫描次数",
  "patrolReports.colCheckpoints": "检查点",
  "patrolReports.colScansHr": "扫描 / 小时",
  "patrolReports.colLastScan": "最后扫描",
  "patrolReports.fullyCovered": "每天都已覆盖",
  "patrolReports.partiallyCovered": "部分天数已覆盖",
  "patrolReports.uncovered": "时段内无扫描",
  "patrolReports.of": "/",
  "patrolReports.coverageTitle": "检查点覆盖情况",
  "patrolReports.coverageSort": "覆盖最少的检查点排在前面。",
  "patrolReports.colCheckpoint": "检查点",
  "patrolReports.colDaysCovered": "覆盖天数",
  "patrolReports.colExpected": "预期",
  "patrolReports.colStatusNow": "当前状态",
  "patrolReports.alertsRaised": "时段内警报",
  "patrolReports.alertsOpen": "仍未处理",
  "patrolReports.alertsResolved": "已解决",
  "patrolReports.repeatTitle": "最常触发警报的检查点",
  "patrolReports.colAlerts": "警报",
  "patrolReports.colOpen": "未处理",
  "patrolReports.colWorst": "最严重逾期",
  "patrolReports.colAvgResolve": "平均解决用时",
  "patrolReports.colLatest": "最近",
  "patrolReports.alertLog": "警报日志",
  "patrolReports.noAlerts": "此时段内无警报。",
  "patrolReports.resolvedIn": "解决用时",
  "patrolReports.stateResolved": "已解决",
  "patrolReports.stateOpen": "未处理",
  "emailPrefs.title": "电子邮件警报偏好",
  "emailPrefs.subtitle": "选择您按站点接收哪些合规邮件。",
  "emailPrefs.loadFailed": "无法加载电子邮件偏好",
  "emailPrefs.saveFailed": "无法保存偏好",
  "emailPrefs.noSites": "您的访问列表中没有站点。",
  "emailPrefs.noPreference": "未保存偏好——适用回退设置",
  "emailPrefs.explainer": "没有人保存偏好的站点将回退为向所有主管和总监发送邮件。在某站点保存任何偏好后，该站点将仅切换为明确选择的收件人。",
  "emailPrefs.overdue": "逾期警报",
  "emailPrefs.overdueHint": "检查点超过其扫描间隔时立即发送邮件",
  "emailPrefs.daily": "每日摘要",
  "emailPrefs.dailyHint": "每天一份合规摘要",
  "emailPrefs.officerSummary": "保安员活动摘要",
  "emailPrefs.officerSummaryHint": "每周记录的活动报告。除非您选择加入，否则关闭。",
  "emailPrefs.manageOthers": "管理此站点的收件人",
  "emailPrefs.noOthers": "此处未配置其他收件人。",
  "emailPrefs.enrollEmail": "email@emoryhealthcare.org",
  "emailPrefs.enrollName": "姓名（可选）",
  "emailPrefs.enroll": "添加收件人",
  "emailPrefs.officerSummaryNote": "保安员活动摘要是一份定期的、包含相关注意事项的已记录扫描活动报告——它不是绩效评分，也绝不会发送给任何未选择加入的人。",
  "officerMap.open": "查看扫描历史地图",
  "officerMap.title": "扫描历史",
  "officerMap.loadFailed": "无法加载扫描历史",
  "officerMap.empty": "所选时间窗内没有归属于此保安员的带 GPS 标记的扫描。",
  "officerMap.firstScan": "首次扫描",
  "officerMap.lastScan": "最后扫描",
  "officerMap.scans": "次扫描",
  "officerMap.ofTotal": "共 {n} 次扫描",
  "officerMap.note": "此处仅显示归属于此保安员的扫描。未登录时进行的扫描为未归属，不予显示。",
  "patrolReports.officersTableTitle": "按保安员记录的活动",


  // --- Officer detail page (synced from en.ts) ---
  "officerDetail.allOfficers": "所有保安员",
  "officerDetail.backToOfficers": "返回保安员",
  "officerDetail.notFound": "未找到保安员。",
  "officerDetail.loadFailed": "无法加载保安员",
  "officerDetail.selfEnrolled": "自助注册",
  "officerDetail.addedBySupervisor": "由主管添加",
  "officerDetail.memberSince": "自 {date} 起加入",
  "officerDetail.totalScans": "扫描总数",
  "officerDetail.shifts": "班次",
  "officerDetail.activeDays": "活跃天数",
  "officerDetail.avgShift": "平均 / 班次",
  "officerDetail.noShiftsYet": "暂无班次",
  "officerDetail.scansPerShift": "每班次扫描次数",
  "officerDetail.lastActive": "最近活跃",
  "officerDetail.whereScanned": "{name} 的扫描位置",
  "officerDetail.mapToLight": "切换到浅色地图",
  "officerDetail.mapToDark": "切换到深色地图",
  "officerDetail.light": "浅色",
  "officerDetail.dark": "深色",
  "officerDetail.noGpsScans": "过去 30 天内没有可在地图上显示的带 GPS 标记的扫描。",
  "officerDetail.scanActivityTitle": "扫描活动——最近 {n} 天",
  "officerDetail.noScansInDays": "最近 {n} 天内未记录任何扫描。",
  "officerDetail.scanHistory": "扫描历史",
  "officerDetail.searchScans": "搜索扫描…",
  "officerDetail.colDateTime": "日期和时间",
  "officerDetail.colLocation": "位置",
  "officerDetail.colHospital": "医院",
  "officerDetail.colCoordinates": "坐标",
  "officerDetail.noScansMatch": "没有与“{q}”匹配的扫描。",
  "officerDetail.showingScans": "显示 {total} 次已记录扫描中的 {shown} 次（过去 30 天）。",
  "officerDetail.timelineRange": "{n} 次扫描 · 从最早 → 最新",
  "officerDetail.hoverTimeline": "将鼠标悬停在时间线上以追踪某次扫描",
  "officerDetail.timelineCaption": "每个圆点代表一次扫描，按发生时间排列，颜色从最早的蓝色到最新的红色。悬停可在地图上高亮显示。扫描之间不绘制路径——仅显示已记录的扫描位置。",


  // --- Scan Map anomaly/misplaced views (synced from en.ts) ---
  "map.officer": "保安员",
  "map.clearOfficer": "清除保安员筛选",
  "map.searchOfficer": "搜索保安员…",
  "map.misplacedTitle": "仅显示 GPS 位置距其检查点超过 1 公里的扫描",
  "map.misplacedOn": "位置偏差",
  "map.misplacedOff": "位置偏差",
  "map.anomaliesTitle": "显示被标记为异常的扫描——保安员行程不可能，或扫描位置远离其所属医院",
  "map.anomalies": "异常",
  "map.popupOfficer": "保安员：",
  "map.anomalousMovement": "异常——此保安员的扫描之间行程不可能",
  "map.anomalousHospital": "异常——位置远离其标注的医院",
  "map.anomalousBoth": "异常——行程不可能且远离其医院",
  "map.metersFromCheckpoint": "距其检查点 {n} 米",
  "map.scansLabel": "次扫描",
  "map.earliest": "最早",
  "map.latest": "最新",

};

export default zh;
